// cookiesChoices.vue file

<template>
    <div class="cookies">
        <div id="cookiesAccept"></div>
        <div id="cookiesScript">
            <!-- Mon Script (ex : Google A,alytics; facebook; twitter; ...) -->
        </div>
        <div class="cookiesMainDiv" :id="close">
            <div>
                <p>{{cookiesChoices_contentInfosMessage}}</p>
            </div>
            <div class="btnCookies">
                <span id="btnAcceptCookies" @click="CookiesAreAccepted(true)">Accepter</span>
                <span id="btnDeclineCookies" @click="CookiesAreAccepted(false)">Refuser</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            cookiesChoices_contentInfosMessage: "Ce site utilise des cookies afin d'analyser le trafic et de mesurer les performances des annonces. En poursuivant votre navigation sur ce site, vous en acceptez l'utilisation",

            htmlChecked: null,
            close: null
        }
    },
    created() {
        var cookiesAccepted = null;

        if(sessionStorage.getItem("cookiesAccepted")) {
            cookiesAccepted = true;
            this.CookiesAreAccepted(cookiesAccepted);
        }
    },
    methods: {
        CookiesAreAccepted(param) {
            if(param) {
                sessionStorage.setItem("cookiesAccepted", "true");
                this.close = "_close";
            } else {
                this.close= "_close";
                // document.getElementById("cookiesAccepted").remove();
                // document.getElementById("cookiesScript").remove();
            }
        }
    }
}
</script>

<style scoped>
.cookiesMainDiv {
    z-index: 9999 !important;
    position: fixed !important;
    background-color: rgba(51, 51, 51, 0.9);
    color: #fff;
    bottom: 0;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: space-around;
}
.cookiesMainDiv a {
    color: #fff;
    text-decoration: underline;
}
.cookiesMainDiv p {
    font-size: 0.9rem;
}
.btnCookies {
    margin-top: 1rem;
}
#btnAcceptCookies,
#btnDeclineCookies {
    padding: 6px;
    cursor: pointer;
    border-radius: 4px;
    margin: 0 8px;
}
#btnAcceptCookies {
    background-color:  rgb(17, 173, 126);
}
#_close {
    display: none;
}

/* RESPONSIF */
@media all and (max-width: 900px) {
    .cookiesMainDiv {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    #btnAcceptCookies,
    #btnDeclineCookies {
        font-size: 1.2rem;
    }
}
</style>